const graphColours = {
  primary: '#2563EB',
  secondary: '#93C5FD',
  tertiary: '#FB923C',
};

export default graphColours;
